import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progress'];

  connect() {
    // A imagem já começa escondida via CSS, só verifica se precisa mostrar
    setTimeout(() => {
      this.updateImageVisibility();
    }, 100);

    // Observa mudanças no turbo frame
    this.turboFrameHandler = () => {
      setTimeout(() => this.updateImageVisibility(), 200);
    };
    document.addEventListener('turbo:frame-render', this.turboFrameHandler);

    // Inicia a barra de carregamento se estiver no step 2
    this.checkAndStartLoading();
  }

  updateImageVisibility() {
    const duduqImage = document.getElementById('graduation-duduq-image');
    if (!duduqImage) {
      return;
    }

    const isStep1 = this.isStep1();

    if (isStep1) {
      this.showImage();
    } else {
      this.hideImage();
    }
  }

  isStep1() {
    // Verifica se existe o formulário específico do step 1
    const step1Form = document.querySelector('#main_form[action*="step=2"]');

    if (step1Form) return true;

    // Verifica se há conteúdo específico do step 1 na página
    const hasStep1Content =
      document.body.textContent.includes('Vamos criar questões juntos?') ||
      document.body.textContent.includes('Quantas questões você quer criar?') ||
      document.body.textContent.includes('Quais serão as disciplinas');

    return hasStep1Content;
  }

  showImage() {
    const duduqImage = document.getElementById('graduation-duduq-image');
    if (duduqImage && window.innerWidth >= 1024) {
      // Only show on desktop (1024px and above)
      duduqImage.classList.remove('tw-hidden');
      duduqImage.style.opacity = '1';
    }
  }

  hideImage() {
    const duduqImage = document.getElementById('graduation-duduq-image');
    if (duduqImage) {
      // Add hidden class to hide completely
      duduqImage.classList.add('tw-hidden');
      duduqImage.style.opacity = '0';
    }
  }

  checkAndStartLoading() {
    // Verifica se estamos no step 2 para iniciar a barra de carregamento
    const isStep2 = this.isStep2();
    if (isStep2) {
      setTimeout(() => {
        this.startLoading();
      }, 300); // Pequeno delay para garantir que o DOM está pronto
    }
  }

  isStep2() {
    // Verifica se há conteúdo específico do step 2 na página
    const hasStep2Content =
      document.body.textContent.includes('Criando questões...') ||
      document.body.textContent.includes('Isso pode levar alguns segundos') ||
      this.hasProgressTarget;

    return hasStep2Content;
  }

  startLoading() {
    this.progress = 0;
    this.loadingInterval = null;

    // Simula uma requisição que leva entre 3-8 segundos
    const totalDuration = 3000 + Math.random() * 5000; // 3-8 segundos
    const updateInterval = 50; // Atualiza a cada 50ms
    const increment = (updateInterval / totalDuration) * 100;

    // Começa com progresso rápido e depois desacelera
    this.simulateProgress(increment, updateInterval);
  }

  simulateProgress(baseIncrement, interval) {
    this.loadingInterval = setInterval(() => {
      // Simula comportamento real de carregamento:
      // - Início rápido (0-30%)
      // - Progresso médio (30-70%)
      // - Desaceleração final (70-95%)
      // - Pequena pausa antes de completar (95-100%)

      if (this.progress < 30) {
        // Fase rápida: incremento normal
        this.progress += baseIncrement * 1.5;
      } else if (this.progress < 70) {
        // Fase média: incremento normal
        this.progress += baseIncrement;
      } else if (this.progress < 95) {
        // Fase de desaceleração: incremento reduzido
        this.progress += baseIncrement * 0.3;
      } else if (this.progress < 98) {
        // Pequena pausa simulando processamento final
        this.progress += baseIncrement * 0.1;
      } else {
        // Completou o carregamento
        this.progress = 100;
        this.completeLoading();
      }

      // Atualiza a barra visualmente
      this.updateProgressBar();
    }, interval);
  }

  updateProgressBar() {
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${Math.min(this.progress, 100)}%`;
    }
  }

  completeLoading() {
    // Limpa o intervalo
    if (this.loadingInterval) {
      clearInterval(this.loadingInterval);
      this.loadingInterval = null;
    }

    // Remove os event listeners após completar o carregamento
    this.cleanupEventListeners();

    // Adiciona um pequeno delay antes de completar visualmente
    setTimeout(() => {
      // Loading completed
    }, 200);
  }

  cleanupEventListeners() {
    // Remove o event listener do turbo frame
    if (this.turboFrameHandler) {
      document.removeEventListener('turbo:frame-render', this.turboFrameHandler);
      this.turboFrameHandler = null;
    }
  }

  disconnect() {
    // Limpa o intervalo quando o controller é desconectado
    if (this.loadingInterval) {
      clearInterval(this.loadingInterval);
      this.loadingInterval = null;
    }

    // Remove o event listener do turbo frame
    if (this.turboFrameHandler) {
      document.removeEventListener('turbo:frame-render', this.turboFrameHandler);
      this.turboFrameHandler = null;
    }
  }
}
